var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 3.75V6H4C2.89543 6 2 6.89543 2 8V8.24981C2.10303 8.24975 2.20772 8.27104 2.30777 8.31606L11.0767 12.2621C11.1337 12.2877 11.1915 12.3109 11.25 12.3316V11C11.25 10.5858 11.5858 10.25 12 10.25C12.4142 10.25 12.75 10.5858 12.75 11V12.3316C12.8085 12.3109 12.8663 12.2877 12.9233 12.2621L21.6922 8.31606C21.7923 8.27104 21.897 8.24975 22 8.24981V8C22 6.89543 21.1046 6 20 6H16.75V3.75C16.75 2.7835 15.9665 2 15 2H9C8.0335 2 7.25 2.7835 7.25 3.75ZM9 3.5H15C15.1381 3.5 15.25 3.61193 15.25 3.75V6H8.75V3.75C8.75 3.61193 8.86193 3.5 9 3.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.82243L13.5389 13.6299C13.2839 13.7447 13.0192 13.8295 12.75 13.8845V15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15V13.8845C10.9808 13.8295 10.7161 13.7447 10.4611 13.6299L2 9.82243V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V9.82243Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase2);
export default __webpack_public_path__ + "static/media/briefcase-2.bc0b7dc939f89de57f12401cde845c52.svg";
export { ForwardRef as ReactComponent };